import { inject, Injectable } from '@angular/core';
import { CanMatch, Route } from '@angular/router';
import { ContextService, Typology } from '@bcef/ia-shared';

@Injectable({ providedIn: 'root' })
export class TypologyGuard implements CanMatch {
  private readonly contextService = inject(ContextService);

  public canMatch(route: Route): boolean {
    const allowed: Typology[] = route.data?.['typology'] ?? [];
    return allowed.includes(this.contextService.typology);
  }
}
